import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "components";
import { t } from "i18next";
import Form from "../components/Form";
import { useIsLoggedIn, useFocus } from "hooks";
import { UTILS } from "utils";
import {
  useVerifyPinMutation,
  useResendOtpMutation,
} from "store/auth/register/registerService";
import C from "Constants";
import { RegisterAction } from "store/actions";
import { BrandAction } from "store/actions";
import AuthHeader from "components/login/AuthHeader";
import { maskPhoneNumber } from "utils/Utils";

const Verification = ({ goToLogin, goToBasket, goToHomePage }) => {
  useIsLoggedIn();
  useFocus("verificationInput");

  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const [verifyPin] = useVerifyPinMutation();
  const [resendOtp] = useResendOtpMutation();
  const [isMounted, setIsMounted] = useState(false);
  const [phoneCountryObj, setPhoneCountryObj] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [seconds, setSeconds] = useState(30);
  const [verificationCode, setVerificationCode] = useState("");
  const {
    loader: { isLoading },
    NotPersist: { pageLoaded },
    cart,
    register: { error },
  } = useSelector((state) => ({
    loader: state.loader,
    NotPersist: state.NotPersist,
    AppReducer: state.AppReducer,
    cart: state?.cart,
    register: state.register,
  }));

  useEffect(() => {
    if (pageLoaded) {
      if (params?.domainName) {
        goToLogin();
      } else {
        window.history.back();
      }
    }
  }, [pageLoaded]);

  const handleChange = (value) => {
    let d = UTILS.NumberConversion(value);
    setVerificationCode(d);
  };
  const { brandInfo: brand } = useSelector(
    (state) => state?.brandStorageReducer
  );

  const verifyOtp = async () => {
    const phoneNumberZeroLess = phoneNumber.replace(/^0+/, "");
    const brandId = brand?.brand?._id;
    if (verificationCode?.length === 4 && isMounted) {
      const obj = {
        brandId: brandId,
        phoneNumber: phoneNumberZeroLess,
        countryObj: phoneCountryObj,
        verificationCode,
      };
      const { data } = await verifyPin(obj);
      if (data?.success === 1 && data?.data?.token) {
        dispatch(BrandAction.getDiscounts({ brandId }));
        if (cart?.cart?.length > 0) {
          goToBasket();
        } else {
          goToHomePage();
        }
        localStorage.setItem("loginEvent", Date.now().toString());
      }
    }
  };
  useEffect(() => {
    verifyOtp();
  }, [verificationCode]);

  useEffect(() => {
    if (isMounted) {
      const state = history?.location?.state;
      if (state?.phoneNumber && state?.countryObj) {
        setPhoneNumber(state.phoneNumber);
        setPhoneCountryObj(state.countryObj);
        const element = document.getElementById("verificationInput");
        element?.focus();
      } else {
        history.goBack();
      }
    } else {
      setIsMounted(true);
    }
  }, [isMounted]);

  // Resend verification code
  const resendCode = async () => {
    const phoneNumberZeroLess = phoneNumber.replace(/^0+/, "");
    if (brand?.brand?._id) {
      const obj = {
        brandId: brand?.brand?._id,
        phoneNumber: phoneNumberZeroLess,
        countryObj: phoneCountryObj,
        userType: C.CUSTOMER,
      };
      const { data } = await resendOtp(obj);
      let d = data?.success === 1 ? setSeconds(30) : "";
    } else {
      dispatch(
        RegisterAction.reSendVerificationCodeFailure(
          t("Something was incorrect.")
        )
      );
    }
  };

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  if (isLoading) return <Spinner />;
  return (
    <>
      <div className="store-page store-page-popup verify-page min-h-app-height my-0 p-4 bg-white">
        <AuthHeader
          goBack={goToLogin}
          description={`We send a code on your WhatsApp`}
          infoContent={<span dir="ltr" className="l-d mx-1 text-16x leading-19x text-shadow-forge-700">
           {maskPhoneNumber(phoneCountryObj?.dialCode, phoneNumber)}
          </span>}
          showInfoAlongWithDescription={true}
          title="Verify your"
          blinkText="WhatsApp"
        />
        <div className="mt-16 pt-15">
        <Form 
          {...{
            verificationCode,
            handleChange,
            seconds,
            error,
            resendCode,
          }}
        />
        </div>
        {/* <div className="mt-148x">
        <CustomButton form="verification-form" type="submit" disabled={verificationCode.length !== 4} onClick={verifyOtp}>
          <TranslationText text="Verify" />
        </CustomButton>
        </div> */}
      </div>
    </>
  );
};

export default Verification;
